import privateInstance from "../privateClient";
import { CalculateOTRQuoteQueryType, SetOfferPriceQueryType } from "./types";

export const otrApi = {
  setOfferPrice: async (params: SetOfferPriceQueryType["Params"]) => {
    try {
      const response = await privateInstance.post<
        SetOfferPriceQueryType["Data"]
      >("/rate-manager/handle-rate-calculation-offer", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  calculateOTRQuote: async (params: CalculateOTRQuoteQueryType["Params"]) => {
    try {
      const { data } = await privateInstance.post<
        CalculateOTRQuoteQueryType["Data"]
      >("/rate-manager/calculate-rate", params);

      return data;
    } catch (error) {
      return null;
    }
  },
};
